import React, {
  useCallback, useState, useEffect, useRef,
} from 'react'
import { formatDeliveryType } from '@usap/core'
import DeliveryDatesWmo from './DeliveryDatesWmo'
import DeliveryDatesLastMile from './DeliveryDatesLastMile'
import GTM from '../../../../../../../helpers/GTM'
import { useDeliveryDatesLastMileEnabled } from '../../../../../../../hooks/useDeliveryDatesLastMile'

const DeliveryDates = props => {
  const { data, dataTestId, zipCode } = props
  const { shippingOption } = data
  const [showPopup, shouldShowPopup] = useState(false)
  const isDeliveryDatesLastMileEnabled = useDeliveryDatesLastMileEnabled()

  const [ground] = (shippingOption?.options || [])
    .filter(current => current.method.toLowerCase() === 'ground')

  const handleSeeAllDates = useCallback(
    () => {
      shouldShowPopup(true)
      GTM.shippingEtaModalGTM('cart')
    },
    [shouldShowPopup],
  )

  const isLastMileImpressionSentRef = useRef(false)
  const deliveryType = ground?.cutoffTime ? formatDeliveryType(ground?.deliveryDate, ground?.cutoffTime) : ground?.deliveryType
  useEffect(() => {
    if (__BROWSER__ && isDeliveryDatesLastMileEnabled &&
      typeof deliveryType !== 'undefined' &&
      !isLastMileImpressionSentRef.current) {
      isLastMileImpressionSentRef.current = true
      GTM.lastMileBadgeImpression({
        badgeType: deliveryType,
        itemCount: data?.modifiers?.quantity,
        zipCodeEligible: zipCode,
        sku: data?.product?.sku,
      })
    }
  }, [data, deliveryType, ground, isDeliveryDatesLastMileEnabled, zipCode])

  if (!ground?.deliveryDate) {
    return null
  }

  if (isDeliveryDatesLastMileEnabled) {
    return (
      <DeliveryDatesLastMile
        ground={ground}
        data={data}
        dataTestId={dataTestId}
        handleSeeAllDates={handleSeeAllDates}
        showPopup={showPopup}
        shouldShowPopup={shouldShowPopup}
        optionsCount={(shippingOption?.options?.length ?? 0) - (shippingOption?.options?.some(option => option.method === 'Ground_unfolded') ? 1 : 0)}
      />
    )
  }

  return (
    <DeliveryDatesWmo
      ground={ground}
      dataTestId={dataTestId}
      handleSeeAllDates={handleSeeAllDates}
      showPopup={showPopup}
      shouldShowPopup={shouldShowPopup}
      data={data}
    />
  )
}

export default DeliveryDates
